module.exports = __webpack_public_path__ + "static/media/right.96ffee08.svg";